var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1044,
    height: 533,
    viewBox: "0 0 1044 533",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 546,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 626,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 658,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 722,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 738,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 770,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 834,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 866,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 882,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 898,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 978,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1010,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1026,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1042,
    cy: 2,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 546,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 626,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 658,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 722,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 738,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 770,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 834,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 866,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 882,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 898,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 978,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1010,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1026,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1042,
    cy: 25,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 458,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 522,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 570,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 602,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 618,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 682,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 698,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 746,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 778,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 794,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 810,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 826,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 858,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 874,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 890,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 922,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 938,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 954,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 970,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 986,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1002,
    cy: 48,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 458,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 522,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 570,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 602,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 618,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 682,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 698,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 746,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 778,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 794,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 810,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 826,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 858,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 874,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 890,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 922,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 938,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 954,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 970,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 986,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1002,
    cy: 71,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 458,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 522,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 570,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 602,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 618,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 682,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 698,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 746,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 778,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 794,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 810,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 826,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 858,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 874,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 890,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 922,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 938,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 954,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 970,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 986,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1002,
    cy: 94,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 458,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 522,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 570,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 602,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 618,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 682,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 698,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 746,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 778,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 794,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 810,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 826,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 858,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 874,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 890,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 922,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 938,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 954,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 970,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 986,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1002,
    cy: 117,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 458,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 522,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 570,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 602,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 618,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 682,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 698,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 746,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 778,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 794,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 810,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 826,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 858,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 874,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 890,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 922,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 938,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 954,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 970,
    cy: 140,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 546,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 626,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 658,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 722,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 738,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 770,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 834,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 866,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 882,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 898,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 978,
    cy: 163,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 546,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 626,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 658,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 722,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 738,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 770,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 834,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 866,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 882,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 898,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962,
    cy: 186,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 546,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 626,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 658,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 722,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 738,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 770,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 834,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 866,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 882,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 898,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 978,
    cy: 209,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 458,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 522,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 570,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 602,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 618,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 682,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 698,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 746,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 778,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 794,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 810,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 826,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 858,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 874,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 890,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 922,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 938,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 954,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 970,
    cy: 232,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 546,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 626,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 658,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 722,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 738,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 770,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 834,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 866,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 882,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 898,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962,
    cy: 255,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 458,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 522,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 570,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 602,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 618,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 682,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 698,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 746,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 778,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 794,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 810,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 826,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 858,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 874,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 890,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 922,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 938,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 954,
    cy: 278,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 458,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 522,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 570,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 602,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 618,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 682,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 698,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 746,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 778,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 794,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 810,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 826,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 858,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 874,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 890,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 922,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 938,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 954,
    cy: 301,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 546,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 626,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 658,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 722,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 738,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 770,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 834,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 866,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 882,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 898,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946,
    cy: 324,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 546,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 626,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 658,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 722,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 738,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 770,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 834,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 866,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 882,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 898,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946,
    cy: 347,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 546,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 626,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 658,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 722,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 738,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 770,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 834,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 866,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 882,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 898,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946,
    cy: 370,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 546,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 626,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 658,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 722,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 738,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 770,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 834,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 866,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 882,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 898,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946,
    cy: 393,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 458,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 522,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 570,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 602,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 618,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 682,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 698,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 746,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 778,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 794,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 810,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 826,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 858,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 874,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 890,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 922,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 938,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 954,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 970,
    cy: 416,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 546,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 626,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 658,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 722,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 738,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 770,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 834,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 866,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 882,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 898,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 978,
    cy: 439,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 546,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 626,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 658,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 722,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 738,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 770,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 834,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 866,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 882,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 898,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962,
    cy: 462,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 546,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 626,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 658,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 722,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 738,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 770,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 834,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 866,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 882,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 898,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 978,
    cy: 485,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 458,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 506,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 522,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 570,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 586,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 602,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 618,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 634,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 682,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 698,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 746,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 762,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 778,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 794,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 810,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 826,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 858,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 874,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 890,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 906,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 922,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 938,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 954,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 970,
    cy: 508,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 546,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 578,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 594,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 626,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 658,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 722,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 738,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 770,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 786,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 818,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 834,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 850,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 866,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 882,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 898,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 914,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 962,
    cy: 531,
    r: 2,
    fill: "#9FBCEF",
    fillOpacity: 0.52
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.4490a2a017c66cc8d905010c35438261.svg";
export { ForwardRef as ReactComponent };